import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d5d5eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5 text-center page-redimir-cupon" }
const _hoisted_2 = {
  key: 0,
  class: "actividad-info mb-4"
}
const _hoisted_3 = { class: "fw-bold text-uppercase mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "actividad-img mb-3"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Datos del usuario", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Apellido:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1))

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { cuponesService } from '@/services/cupones.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'RedimirCupon',
  setup(__props) {

const codigo = ref('')
const mensaje = ref('')
const exito = ref<boolean | null>(null)
const usuario = ref<any>(null)
const actividad = ref<any>(null)

async function buscarCuponPorHash(cuponId: string, hash: string) {
  try {
    const dataA = await cuponesService.buscarCuponPorHash(cuponId, hash)
    const data = dataA.data
    exito.value = data.success === true
    mensaje.value = data.message || ''
    codigo.value = data.cupon?.codigo || ''
    usuario.value = data.usuario || null
    actividad.value = data.actividad || null

    return
  } catch (e) {
    console.error('Error al buscar cupón:', e)
  }
  exito.value = null
  mensaje.value = 'Cupón no válido o no encontrado.'
  codigo.value = ''
  usuario.value = null
  actividad.value = null
}

const route = useRoute()
onMounted(() => {
  const cuponId = route.params.cuponId as string | undefined
  const hash = route.params.hash as string | undefined

  if (cuponId && hash) {
    buscarCuponPorHash(cuponId, hash)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (actividad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(actividad.value.nombre), 1),
          (actividad.value.slider && actividad.value.slider.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: actividad.value.slider[0].path,
                  alt: actividad.value.nombre,
                  class: "img-fluid rounded shadow",
                  style: {"max-width":"400px"}
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "actividad-desc mb-3",
            innerHTML: actividad.value.descripcion
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    (exito.value !== false && !(exito.value === null && mensaje.value && mensaje.value !== ''))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redimirCupon && _ctx.redimirCupon(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codigo).value = $event)),
                class: "form-control text-center",
                placeholder: "Código de cupón",
                disabled: ""
              }, null, 512), [
                [_vModelText, codigo.value]
              ])
            ])
          ], 32),
          (usuario.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", null, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(usuario.value.nombre), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(usuario.value.apellido), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(usuario.value.email), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (mensaje.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["mt-4", {
      'alert': true,
      'alert-success': exito.value,
      'alert-danger': !exito.value && mensaje.value && mensaje.value !== ''
    }])
        }, _toDisplayString(mensaje.value), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})